export function getDisplayUnitFromParameterCode(parameterCode: string, paramName: string): string {
  const unit = getUnitForOpenMeteoParameter(paramName);
  if (unit !== "") return unit;

  const lowerName = paramName.toLowerCase();
  if (lowerName.includes("wildfire")) return "Index";
  if (lowerName.includes("storm reports")) return "";
  return "";
}

export function getUnitForOpenMeteoParameter(paramName: string): string {
  const lowerName = paramName.toLowerCase();
  if (lowerName.includes("temp")) return "°C";
  if (lowerName.includes("wind")) return "km/h";
  if (
    lowerName.includes("precip") || lowerName.includes("rain") || 
    lowerName.includes("showers") || lowerName.includes("snowfall") || 
    lowerName.includes("evapotranspiration")
  ) {
    if (lowerName.includes("snowfall")) return "cm";
    if (lowerName.includes("et0")) return "mm";
    return "mm";
  }
  if (lowerName.includes("hours")) return "hours";
  if (lowerName.includes("probability")) return "%";
  if (lowerName.includes("direction")) return "°";
  if (lowerName.includes("radiation")) return "MJ/m²";
  if (lowerName.includes("uv_index")) return "Index";
  if (lowerName.includes("sunshine_duration") || lowerName.includes("daylight_duration")) return "seconds";
  return "";
}